import React, { useMemo } from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";

interface Row {
    key: string;
    [key: string]: any;
}

export default function ReportDashboard() {
    const { t } = useTranslation();
    // ===================== TABLE 1 =====================
    const topData: Row[] = [
        {
            key: "1",
            year: "2026",
            month: "Tháng 1",
            newHair: 99,
            spKhac: 1,
            cnc: 25,
            congChi: 2,
            giamCan: "-",
            pttm: 5,
            noiKhoa: 13,
            dieuTri: 9,
            phunXam: 5,
            dvKhac: 10,
            spToc: "-",
            tong: 169,
        },
        {
            key: "2",
            year: "2026",
            month: "Tháng 2",
            newHair: 74,
            spKhac: "-",
            cnc: 9,
            congChi: 3,
            giamCan: "-",
            pttm: 2,
            noiKhoa: 3,
            dieuTri: 2,
            phunXam: 2,
            dvKhac: 3,
            spToc: 2,
            tong: 100,
        },
        {
            key: "3",
            year: "2026",
            month: "Tháng 3",
            newHair: 37,
            spKhac: 1,
            cnc: 6,
            congChi: 1,
            giamCan: "-",
            pttm: "-",
            noiKhoa: 4,
            dieuTri: 3,
            phunXam: 1,
            dvKhac: 4,
            spToc: 1,
            tong: 58,
        },
        {
            key: "4",
            year: "2025",
            month: "Tháng 10",
            newHair: 79,
            spKhac: 1,
            cnc: 28,
            congChi: 3,
            giamCan: 1,
            pttm: 5,
            noiKhoa: 7,
            dieuTri: 7,
            phunXam: 3,
            dvKhac: 4,
            spToc: 8,
            tong: 146,
        },
    ];

    const summary = {
        key: "total",
        year: "Tổng",
        month: "",
        newHair: 437,
        spKhac: 6,
        cnc: 109,
        congChi: 22,
        giamCan: 4,
        pttm: 19,
        noiKhoa: 44,
        dieuTri: 33,
        phunXam: 19,
        dvKhac: 31,
        spToc: 16,
        tong: 760,
    };

    const topColumns: ColumnsType<Row> = [
        {
            title: t('report.year'),
            dataIndex: "year",
            render: (v, row, i) => {
                if (row.key === "total") return v;
                return {
                    children: v,
                    props: { rowSpan: i === 0 ? 3 : i === 3 ? 1 : 0 },
                };
            },
        },
        { title: t('report.month'), dataIndex: "month" },
        { title: "1. New Hairs", dataIndex: "newHair" },
        { title: "12. Sản phẩm khác", dataIndex: "spKhac" },
        { title: "2. CNC", dataIndex: "cnc" },
        { title: "3. Căng chỉ", dataIndex: "congChi" },
        { title: "4. Giảm cân", dataIndex: "giamCan" },
        { title: "5. PTTM", dataIndex: "pttm" },
        { title: "6. TM nội khoa", dataIndex: "noiKhoa" },
        { title: "7. Điều trị da", dataIndex: "dieuTri" },
        { title: "8. Phun xăm", dataIndex: "phunXam" },
        { title: "9. DV khác", dataIndex: "dvKhac" },
        { title: "Sản phẩm tóc", dataIndex: "spToc" },
        { title: t('report.total'), dataIndex: "tong", render: (v) => <strong>{v}</strong> },
    ];

    // ===================== TABLE 2 (LEFT) =====================
    const statusData: Row[] = [
        { key: "1", week: 1, status: "Thanh toán hết", t3: 11, t2: 16, t1: 15 },
        { key: "2", week: "", status: "Cọc trực tiếp", t3: 6, t2: 11, t1: 9 },
        { key: "3", week: "", status: "Rớt", t3: 15, t2: 5, t1: 3 },
        { key: "4", week: "", status: "Cọc online", t3: 2, t2: 4, t1: "-" },

        { key: "5", week: 2, status: "Thanh toán hết", t3: 11, t2: 4, t1: 15 },
        { key: "6", week: "", status: "Rớt", t3: 7, t2: 8, t1: 6 },
        { key: "7", week: "", status: "Cọc trực tiếp", t3: 5, t2: 7, t1: 8 },
        { key: "8", week: "", status: "Cọc online", t3: 1, t2: 3, t1: 2 },

        { key: "9", week: 3, status: "Thanh toán hết", t3: "-", t2: "-", t1: 24 },
        { key: "10", week: "", status: "Cọc trực tiếp", t3: "-", t2: "-", t1: 6 },
        { key: "11", week: "", status: "Rớt", t3: "-", t2: "-", t1: 5 },
        { key: "12", week: "", status: "Cọc online", t3: "-", t2: "-", t1: 5 },
    ];

    const statusColumns: ColumnsType<Row> = [
        {
            title: t('report.week'),
            dataIndex: "week",
            render: (v, row, i) => {
                const map = [0, 4, 8];
                if (map.includes(i)) {
                    return { children: v, props: { rowSpan: 4 } };
                }
                return { children: null, props: { rowSpan: 0 } };
            },
        },
        { title: t('report.status'), dataIndex: "status" },
        { title: t('report.month_3'), dataIndex: "t3" },
        { title: t('report.month_2'), dataIndex: "t2" },
        { title: t('report.month_1'), dataIndex: "t1" },
    ];

    // ===================== TABLE 3 (RIGHT) =====================
    const typeData: Row[] = [
        { key: "1", week: 1, type: "Khách mới", t3: 32, t2: 28, t1: 20 },
        { key: "2", week: "", type: "Khách cũ", t3: 2, t2: 7, t1: 5 },
        { key: "3", week: "", type: "Khách quay lại", t3: "-", t2: 1, t1: 2 },

        { key: "4", week: 2, type: "Khách mới", t3: 21, t2: 21, t1: 28 },
        { key: "5", week: "", type: "Khách cũ", t3: 2, t2: 1, t1: 3 },

        { key: "6", week: 4, type: "Khách mới", t3: "-", t2: 37, t1: 47 },
        { key: "7", week: "", type: "Khách cũ", t3: "-", t2: 4, t1: 5 },
    ];

    const typeColumns: ColumnsType<Row> = [
        {
            title: t('report.week'),
            dataIndex: "week",
            render: (v, row, i) => {
                const rowSpan = getWeekRowSpan(typeData, i);

                return {
                    children: v,
                    props: { rowSpan },
                };
            },
        },
        { title: t('report.customer_classification'), dataIndex: "type" },
        { title: t('report.month_3'), dataIndex: "t3" },
        { title: t('report.month_2'), dataIndex: "t2" },
        { title: t('report.month_1'), dataIndex: "t1" },
    ];

    const getWeekRowSpan = (data: any[], index: number) => {
        // nếu là dòng phụ thì ẩn
        if (!data[index].week) {
            return 0;
        }

        let count = 1;

        for (let i = index + 1; i < data.length; i++) {
            if (!data[i].week) {
                count++;
            } else {
                break;
            }
        }

        return count;
    };

    return (
        <div className="bg-gray-100 dark:bg-[#0f172a] min-h-screen space-y-4">
            {/* TOP TABLE */}
            <div className="bg-white dark:bg-[#1e293b] p-2 rounded-xl">
                <h2 className="font-semibold mb-2 text-000000e0">
                    {t('report.customer_by_service')}
                </h2>
                <Table
                    columns={topColumns}
                    dataSource={[...topData, summary]}
                    pagination={false}
                    size="small"
                    rowClassName={(record) =>
                        record.key === "total" ? "row-total" : ""
                    }
                    scroll={{ x: "max-content" }}
                    className="custom-ant-table"
                />
            </div>

            {/* BOTTOM */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                <div className="bg-white dark:bg-[#1e293b] p-2 rounded-xl">
                    <h3 className="font-semibold mb-2 text-000000e0">
                        {t('report.customer_status')}
                    </h3>
                    <Table
                        columns={statusColumns}
                        dataSource={statusData}
                        pagination={false}
                        size="small"
                        scroll={{ x: "max-content" }}
                        className="custom-ant-table"
                    />
                </div>

                <div className="bg-white dark:bg-[#1e293b] p-2 rounded-xl">
                    <h3 className="font-semibold mb-2 text-000000e0">
                        {t('report.customer_type')}
                    </h3>
                    <Table
                        columns={typeColumns}
                        dataSource={typeData}
                        pagination={false}
                        size="small"
                        scroll={{ x: "max-content" }}
                        className="custom-ant-table"
                    />
                </div>
            </div>
        </div>
    );
}